import { FC } from 'react';
import { AllieIconButton } from '../../../../components';
import {
  OrderProgressButtonsActionsProps,
  OrderProgressButtonsProps,
} from '../ProductionOrder.types';
import { AlliePauseCircleOutlineIcon, AllieStopCircleOutlineIcon } from '../../../../styling/icons';
import { StyledDescText } from '../ProductionOrder.styles';
import { isTablet } from '../../../../common/utils';

const namespace = 'production-order';

export const OrderProgressButtons: FC<
  OrderProgressButtonsProps & OrderProgressButtonsActionsProps
> = ({ onClickCloseOp, onClickPauseOp, ...labels }) => {
  return (
    <>
      <AllieIconButton
        fill="outline"
        allieType="secondary"
        allieColor="neutral"
        allieSize="small"
        corner="rounded-edges"
        className={`allie-text-button-normal ${namespace}__action-button`}
        onClick={() => onClickCloseOp()}
        style={{ margin: 0 }}
      >
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <AllieStopCircleOutlineIcon style={{ width: 20, height: 20 }} />
          <StyledDescText type="body3" weight={500}>
            {labels.close}
          </StyledDescText>
        </div>
      </AllieIconButton>
      <AllieIconButton
        fill="outline"
        allieType="secondary"
        allieColor="neutral"
        allieSize="small"
        corner="rounded-edges"
        className={`allie-text-button-normal ${namespace}__action-button`}
        onClick={onClickPauseOp}
        style={{ margin: 0 }}
      >
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <AlliePauseCircleOutlineIcon style={{ width: 20, height: 20 }} />
          {isTablet && (
            <StyledDescText type="body3" weight={500}>
              {labels.pause}
            </StyledDescText>
          )}
        </div>
      </AllieIconButton>
    </>
  );
};
